import { useCallback } from 'react';

import { DoubleArrow, DownArrow, UpArrow } from 'ui/icons';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { HeaderButtonCell } from './HeaderRowCell.styles';
import { DESTINATION_TABLE_COLUMN, DestinationTableHeader } from 'modules/dataSync/types';

type ColumnType = DestinationTableHeader;

type HeaderRowCellProps<T> = {
  column: ColumnType;
  columnId: T;
  isActiveSortColumn: boolean;
  sortDirection: SORT_DIRECTIONS;
  setSortedBy: (sortedBy: T) => void;
  setSortDirection: (sortDirection: SORT_DIRECTIONS) => void;
  inPage?: boolean;
};

export const HeaderRowCell = <T extends DESTINATION_TABLE_COLUMN>({
  column,
  columnId,
  isActiveSortColumn,
  sortDirection,
  setSortDirection,
  setSortedBy,
}: HeaderRowCellProps<T>) => {
  const isAscendingSort = sortDirection === SORT_DIRECTIONS.ASCENDING;

  const handleClick = useCallback(() => {
    const newDirection = isAscendingSort ? SORT_DIRECTIONS.DESCENDING : SORT_DIRECTIONS.ASCENDING;

    setSortedBy(columnId);
    setSortDirection(newDirection);
  }, [setSortDirection, setSortedBy, columnId, isAscendingSort]);

  return (
    <HeaderButtonCell
      as="button"
      data-test={`column-header-${column.id}`}
      data-sorted-column={isActiveSortColumn}
      key={column.id}
      onClick={handleClick}
    >
      <span>{column.label}</span>

      {!isActiveSortColumn && <DoubleArrow isColorInherited />}
      {isActiveSortColumn && isAscendingSort && <UpArrow isColorInherited />}
      {isActiveSortColumn && !isAscendingSort && <DownArrow isColorInherited />}
    </HeaderButtonCell>
  );
};
